import {
  Component,
  DestroyRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import Swal from 'sweetalert2';
import { Orders } from 'src/app/models/Orders.model';
import { Products } from 'src/app/models/Product.model';
import { OrdersService } from 'src/app/services/orders.service';
import { OpenModalService } from 'src/app/services/shared/open-modal.service';
import { PreparazioneOrdiniDetaggliComponent } from '../../preparazione-ordini-detaggli.component';

/**
 * Sub-modale "Codici QR sub-prodotto" — visualizza i barcode di un
 * sub-product.
 *
 * Cross-use: usato sia in `confirm-products` (J.4 wizard picking) che
 * in `storico-ordini/product-details-storico` (v2.9.0). Touch leggero
 * in J.4.c: @Input/@Output preservati.
 *
 * Cleanup v2.11.0 J.4.c:
 * - 🚨 FIX BUG: metodo `eleteBarcode` (typo, manca "d") duplicato di
 *   `deleteBarcode`. Drop typo.
 * - 🚨 FIX DEAD: variabile `orderToUpdate` calcolata ma mai usata.
 * - Drop ~12 console.log (incluso "MAMA MEA E FLORAREASA" 🇷🇴 ×2 —
 *   "mia madre è fioraia").
 * - Switch a inject() + takeUntilDestroyed.
 */
@Component({
  selector: 'app-subproduct-qrcode',
  templateUrl: './subproduct-qrcode.component.html',
  styleUrls: ['./subproduct-qrcode.component.scss'],
  standalone: false,
})


export class SubproductQrcodeComponent implements OnInit {

  @Input() openedSubQrs = false;
  @Input() subProduct: any;
  @Input() order!: Orders.Order;
  @Output() public valueChange = new EventEmitter<boolean>();

  // === DI ===
  private destroyRef = inject(DestroyRef);
  private orderService = inject(OrdersService);
  private parentComponent = inject(PreparazioneOrdiniDetaggliComponent, { optional: true });
  public closeServ = inject(OpenModalService);

  // === State ===
  public parentProduct: Products.Product | null = null;
  public index = -1;
  public index_subProduct = -1;

  ngOnInit(): void {
    this.parentProduct =
      this.order.products.find((prod) =>
        prod.sub_products?.some(
          (sub) => sub.osp_sub_pr_id === this.subProduct?.osp_sub_pr_id,
        ),
      ) ?? null;

    if (this.parentProduct) {
      this.index = this.order.products.indexOf(this.parentProduct);
      this.index_subProduct = this.parentProduct.sub_products.indexOf(this.subProduct);
    }
  }

  close(): void {
    this.closeServ.seeQrSubOff();
  }

  deleteBarcode(barcode: Products.Barcodes): void {
    barcode.barcode_text = null;
    barcode.lot = null;
    barcode.progressive = null;
  }

  updateOrder(): void {
    if (this.index === -1 || !this.parentProduct) return;

    this.parentProduct.sub_products[this.index_subProduct] = this.subProduct;
    this.order.products[this.index] = this.parentProduct;

    this.orderService
      .updateLazyOrder(this.order)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        if (!data?.success) return;
        Swal.fire({
          icon: 'success',
          title: 'Modifiche!',
          text: 'QR sub-prodotto aggiornati con successo.',
          timer: 1500,
          timerProgressBar: true,
        });
        this.parentComponent?.triggerFunctionSubject?.next(true);
        this.closeServ.seeQrSubOff();
      });
  }
  
}
